// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "lead_activity".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "lead_activity" table (1:1 with a DB row, on the wire). */
export const leadActivityAtomSchema = z.object({
    id: z.string(),
    leadId: z.string(),
    type: z.string(),
    description: z.string().nullable(),
    metadata: z.unknown().nullable(),
    performedById: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=leadActivity.js.map